import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TenantJumpboxComponent } from './tenant-jumpbox.component';
import { ExternalTenantGuard } from 'src/app/services/util/external-tenant.guard';

const routes: Routes = [
  {
    path: '',
    component: TenantJumpboxComponent,
    title: 'Jumpbox',
    canActivate: [ExternalTenantGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TenantJumpboxRoutingModule { }
